import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { Window, StatCard, Loading } from "../../components/VB";

export default function AdminDashboard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/dashboard/admin");
        setData(data);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) return <Loading />;
  if (!data) return null;

  return (
    <div>
      <Window title="Dashboard Admin">
        <h2 className="vb-h1">Ringkasan Hari Ini & Bulan Ini</h2>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))",
            gap: 10,
            marginTop: 12,
          }}
        >
          <StatCard label="Total Karyawan" value={data.total_karyawan} testId="stat-total-karyawan" />
          <StatCard label="Total Divisi" value={data.total_divisi} testId="stat-total-divisi" />
          <StatCard label="Total Jabatan" value={data.total_jabatan} testId="stat-total-jabatan" />
          <StatCard label="Hadir Hari Ini" value={data.hadir_today} testId="stat-hadir-today" />
          <StatCard label="Tidak Hadir Hari Ini" value={data.tidak_hadir_today} testId="stat-tidakhadir-today" />
          <StatCard label="Izin Pending" value={data.izin_pending} testId="stat-izin-pending" />
          <StatCard label="Izin Approved (Bulan)" value={data.izin_approved_bulan} testId="stat-izin-approved" />
          <StatCard label="Izin Rejected (Bulan)" value={data.izin_rejected_bulan} testId="stat-izin-rejected" />
        </div>
      </Window>

      <Window title="Ringkasan Absensi Bulan Ini">
        <table className="vb-table">
          <thead>
            <tr>
              <th>Status</th>
              <th style={{ textAlign: "right" }}>Jumlah</th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(data.monthly_absensi || {}).length === 0 && (
              <tr><td colSpan={2} style={{ textAlign: "center", padding: 20, color: "#666" }}>Belum ada data absensi bulan ini</td></tr>
            )}
            {Object.entries(data.monthly_absensi || {}).map(([k, v]) => (
              <tr key={k}>
                <td>{k}</td>
                <td style={{ textAlign: "right" }}>{v}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Window>

      <Window title="Top Karyawan Berdasarkan Poin Kinerja">
        <table className="vb-table">
          <thead>
            <tr>
              <th>Ranking</th>
              <th>No. Karyawan</th>
              <th>Nama</th>
              <th style={{ textAlign: "right" }}>Total Poin</th>
            </tr>
          </thead>
          <tbody>
            {(data.top_karyawan || []).length === 0 && (
              <tr><td colSpan={4} style={{ textAlign: "center", padding: 20, color: "#666" }}>Belum ada data poin</td></tr>
            )}
            {(data.top_karyawan || []).map((t, i) => (
              <tr key={t.employee_id} data-testid={`top-employee-${i}`}>
                <td>{i + 1}</td>
                <td>{t.no_karyawan}</td>
                <td>{t.nama}</td>
                <td style={{ textAlign: "right" }}>{t.total_poin}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Window>
    </div>
  );
}
